import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/Form/Form";
import FormTitle from "../../../../components/FormTitle/FormTitle";
import Input from "../../../../components/Input/Input";
import Loader from "../../../../components/Loader/Loader";
import { useListManager } from "../../../../contexts/list.manager";
import "./FormRoles.css";
import RoleService from "../../../../services/RolesService";
import { LevelSelector } from "../../../../components/LevelSelector/LevelSelector";
import { TagSingleSelector } from "../../../../components/TagSingleSelector/TagSingleSelector";
import { IdCardLanyard } from "lucide-react";
import { PoliciesDDL } from "../../../../components/PoliciesDDL/PoliciesDDL";

function FormRoles(props) {
	const [name, setName] = useState(props.role?.name || "");
	const [tag, setTag] = useState(props.role?.tag ?? null);
	const [selectedPolicies, setSelectedPolicies] = useState(null);
	const [levels, setLevels] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const { closeForm } = useListManager();
	const navigate = useNavigate();

	useEffect(() => {
		setName(props.role?.name || "");
		setSelectedPolicies(props.role?.policies || []);
		setLevels(props.role?.levels?.map(level => ({ unitId: `${level.unitId}`, hierarchy: level.childrenAuthorized })) || []);
	}, [props.role]);

	const buildPayload = () => {
		return {
			name,
			policies: selectedPolicies?.map(selectedPolicy => selectedPolicy.value),
			levels: levels.map(level => ({
				unitId: isNaN(`${level.unitId}`) ? 'root' : `${level.unitId}`,
				childrenAuthorized: level.hierarchy
			})),
			tagExternalId: tag?.externalId,
		};
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (props.type === "edicao") {
			handleEdit();
			return;
		}
		setShowLoader(true);
		const payload = buildPayload();
		const response = await RoleService.createRole(payload);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-papeis", {
			state: { refresh: true }
		});
	}

	async function handleEdit() {
		setShowLoader(true);
		const payload = buildPayload();
		const response = await RoleService.updateRole(
			props.role.id,
			payload
		);
		setShowLoader(false);
		if (response.data.id) navigate("../consulta-papeis");
	}

	async function handleDelete() {
		setShowLoader(true);
		if (!props.role) return;
		await RoleService.deleteRole(props.role.id);
		navigate("../consulta-papeis", {
			state: { deletedId: props.role.id },
		});
		setShowLoader(false);
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.role) return;
		navigate(`/papeis/${props.role.externalId}`, { state: props.role });
	};

	const handleDualList = (notSelected, selected) => {
		setSelectedPolicies(selected);
	};

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<IdCardLanyard size={23} />}
				tituloConsulta={props.role?.name || null}
				tituloCadastro="Cadastro de Perfil"
				backRoute={"/consulta-papeis"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleDelete={handleDelete}
					handleClickEdit={handleClickEditButton}
					navigateCancelUrl="../consulta-papeis"
				>
					<div className="role-form-grid">
						<div className={props.type === 'consulta' ? `w-full` : 'grid-2'}>
							<Input
								name="name"
								id="name"
								labelText="Nome do perfil *"
								value={name}
								onChange={({ target }) => setName(target.value)}
								disabled={props.type === "consulta"}
								required={true}
							/>
							<TagSingleSelector
								selectedTag={tag}
								onTagChange={_tag => {
									setTag(_tag);
									if (!props.role?.name || props.role?.name === '') {
										setName(_tag.name);
									}
								}}
								disabled={props.type === 'consulta'}
							/>
						</div>
						{props.type !== "consulta" && (
							<>
								<LevelSelector
									onChange={(levels) => {
										setLevels(levels.map(level => ({
											unitId: level.unitId,
											hierarchy: level.childrenAuthorized
										})));
									}}
									levels={levels.map(level => ({
										unitId: level.unitId,
										childrenAuthorized: level.hierarchy
									}))}
									showRoot={true}
									type={props.type}
									title={"Níveis"}
									description={"Selecione os níveis que o perfil pertence"} />
								{selectedPolicies && (
									<div className="form-cond-dual-list-container w-full!">
										<PoliciesDDL
											onChangeList={handleDualList}
											policies={selectedPolicies}
										/>
									</div>
								)}
							</>
						)}
					</div>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormRoles;
